import { Route, Routes, useLocation } from 'react-router-dom';

import { AuthGuard } from './components/AuthGuard';
import { MeridianGuard } from './components/MeridianGuard';
import { Navigation } from './components/Navigation';
import { getLayoutConfig } from './config/layout';
import ArenaResultsPage from './pages/arena/ArenaResultsPage';
import ArenaVotePage from './pages/arena/ArenaVotePage';
import ArenaHomePage from './pages/ArenaHomePage';
import CommunityVotesPage from './pages/CommunityVotesPage';
import ConfigsPage from './pages/configs/ConfigsPage';
import EvalConfigsPage from './pages/eval/configs/EvalConfigsPage';
import EvalRedirect from './pages/eval/EvalRedirect';
import LLMJudgeAdminPage from './pages/eval/llm-judge/AdminPage';
import EvalPromptsPage from './pages/eval/prompts/EvalPromptsPage';
import EvalResultsPage from './pages/eval/results/EvalResultsPage';
import UnifiedPromptDetailPage from './pages/eval/unified/UnifiedPromptDetailPage';
import UnifiedPromptsPage from './pages/eval/unified/UnifiedPromptsPage';
import UserStatsPage from './pages/eval/user-stats/UserStatsPage';
import CreateJudgeConfigPage from './pages/judge-configs/CreateJudgeConfigPage';
import JudgeConfigsPage from './pages/judge-configs/JudgeConfigsPage';
import LeaderboardPage from './pages/leaderboard/LeaderboardPage';
import StatsPage from './pages/leaderboard/StatsPage';
import { PrivacyPolicyPage, TermsOfServicePage } from './pages/legal';
// Pages
import LoginPage from './pages/LoginPage';
import NotFoundPage from './pages/NotFoundPage';

export default function App() {
  const location = useLocation();
  const layout = getLayoutConfig(location.pathname);

  return (
    <div
      className="min-h-screen"
      style={{ backgroundColor: 'var(--color-cream)' }}
    >
      {!layout.isEvalRoute && !layout.isLoginRoute && !layout.hideNav && (
        <Navigation />
      )}
      <main
        className={
          layout.isEvalRoute || layout.isLoginRoute || layout.hasHero
            ? ''
            : 'pt-14'
        }
      >
        <Routes>
          {/* Public routes */}
          <Route path="/login" element={<LoginPage />} />
          <Route path="/" element={<ArenaHomePage />} />
          <Route path="/arena-home" element={<ArenaHomePage />} />
          <Route
            path="/arena/:id"
            element={
              <AuthGuard redirectTo="/">
                <ArenaVotePage />
              </AuthGuard>
            }
          />
          <Route
            path="/arena/:id/results"
            element={
              <AuthGuard redirectTo="/">
                <ArenaResultsPage />
              </AuthGuard>
            }
          />
          <Route path="/terms" element={<TermsOfServicePage />} />
          <Route path="/privacy" element={<PrivacyPolicyPage />} />
          <Route path="/leaderboard" element={<LeaderboardPage />} />
          <Route
            path="/leaderboard/stats"
            element={
              <MeridianGuard>
                <StatsPage />
              </MeridianGuard>
            }
          />
          <Route
            path="/community-votes"
            element={
              <MeridianGuard>
                <CommunityVotesPage />
              </MeridianGuard>
            }
          />

          {/* Meridian-only routes: Evaluation system */}
          <Route
            path="/eval"
            element={
              <MeridianGuard>
                <EvalRedirect />
              </MeridianGuard>
            }
          />
          <Route
            path="/eval/prompts"
            element={
              <MeridianGuard>
                <EvalPromptsPage />
              </MeridianGuard>
            }
          />
          <Route
            path="/eval/configs"
            element={
              <MeridianGuard>
                <EvalConfigsPage />
              </MeridianGuard>
            }
          />
          <Route
            path="/eval/results"
            element={
              <MeridianGuard>
                <EvalResultsPage />
              </MeridianGuard>
            }
          />
          <Route
            path="/eval/unified"
            element={
              <MeridianGuard>
                <UnifiedPromptsPage />
              </MeridianGuard>
            }
          />
          <Route
            path="/eval/unified/:id"
            element={
              <MeridianGuard>
                <UnifiedPromptDetailPage />
              </MeridianGuard>
            }
          />
          <Route
            path="/eval/llm-judge"
            element={
              <MeridianGuard>
                <LLMJudgeAdminPage />
              </MeridianGuard>
            }
          />
          <Route
            path="/eval/user-stats"
            element={
              <MeridianGuard>
                <UserStatsPage />
              </MeridianGuard>
            }
          />

          {/* Meridian-only routes: Configuration */}
          <Route
            path="/judge-configs"
            element={
              <MeridianGuard>
                <JudgeConfigsPage />
              </MeridianGuard>
            }
          />
          <Route
            path="/judge-configs/create"
            element={
              <MeridianGuard>
                <CreateJudgeConfigPage />
              </MeridianGuard>
            }
          />
          <Route
            path="/configs"
            element={
              <MeridianGuard>
                <ConfigsPage />
              </MeridianGuard>
            }
          />

          {/* Catch-all 404 */}
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </main>
    </div>
  );
}
